<template>
    <div class="preloader" v-if="start && displayLoader">
        <div class="logo">
            <img src="@/assets/images/PEDDLR-GIF-200x50.gif" alt="">
        </div>
    </div>
</template>

<script>
    import { smartRaffleComputed} from "@/state/helpers";
    export default {
        props: ["start"],
        computed: {
            ...smartRaffleComputed
        },
    }
</script>

<style lang="scss" scoped>

    .preloader {
        z-index:9999;
        width: 100%;
        height: 100%;
        background-color: rgba($color: #fff, $alpha: 0.4);
        position: fixed;
    }

    .logo {
        position: absolute;
        top: 40%;
        left: 46%;
        margin: 0 auto;
        height: 100%;
    }

</style>